import { Pencil, Trash2 } from 'lucide-react';
import type { getPressList } from '@generated/server/press';
import { PRESS_STATUSES } from '@generated/server/press';

export type Outlet = Awaited<ReturnType<typeof getPressList>>['items'][number];
export type Status = (typeof PRESS_STATUSES)[number];

interface Props { o: Outlet; label: string; confirming: boolean; onStatus: (s: Status) => void; onEdit: () => void; onAskDelete: () => void; onDelete: () => void; onKeep: () => void }

/** Status select + edit + delete (with in-page confirm) for one row of the PR list. */
export function PressControls({ o, label, confirming, onStatus, onEdit, onAskDelete, onDelete, onKeep }: Props) {
  return (
    <div className="flex shrink-0 flex-wrap items-end gap-2">
      <label className="text-xs font-semibold uppercase tracking-wider">
        Status
        <select value={o.outreachStatus ?? 'Not Contacted'} onChange={(e) => onStatus(e.target.value as Status)} className="mt-1 block min-h-11 w-full border-2 border-foreground bg-card px-2 text-sm font-semibold normal-case tracking-normal sm:w-44">
          {PRESS_STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
        </select>
      </label>
      <button type="button" onClick={onEdit} aria-label={`Edit ${label}`} title="Edit" className="inline-flex min-h-11 min-w-11 items-center justify-center border-2 border-foreground hover:bg-muted"><Pencil className="h-4 w-4" /></button>
      {confirming ? (
        <span className="flex items-center gap-1">
          <button type="button" onClick={onDelete} className="min-h-11 border-2 border-destructive bg-destructive px-3 text-sm font-semibold text-background">Delete</button>
          <button type="button" onClick={onKeep} className="min-h-11 border-2 border-foreground px-3 text-sm font-semibold">Keep</button>
        </span>
      ) : (
        <button type="button" onClick={onAskDelete} aria-label={`Delete ${label}`} title="Delete" className="inline-flex min-h-11 min-w-11 items-center justify-center border-2 border-foreground hover:bg-destructive hover:text-background"><Trash2 className="h-4 w-4" /></button>
      )}
    </div>
  );
}

export function EmailLine({ o }: { o: Outlet }) {
  return o.email?.email ? <a className="break-all underline" href={`mailto:${o.email.email}`}>{o.email.email}</a> : <span className="text-xs italic text-muted-foreground">No email yet</span>;
}
